import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const HomeTimeTableLazy = React.lazy(
	() => import(/* webpackChunkName : 'HomeTimeTable' */ './components')
);

export default (store) => {
	return [
		{
			path: 'home/timetable',
			element: (
				<AsyncLoading
					component={
						<HomeTimeTableLazy
							featureFlag="Module:TimeTable"
							permission="CanViewTimeTable"
						/>
					}
				/>
			),
		},
	];
};
